import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  testimonialResponse: {},
  testimonials: [],
  selectedTestimonial: {},
};

const testimonialSlice = createSlice({
  name: "testimonial",
  initialState,
  reducers: {
    isPending: (state) => {
      state.isLoading = true;
    },

    // Create
    createTestimonialSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.testimonials.push(payload || {});
      state.testimonialResponse = payload || {};
    },

    // Get all
    getTestimonialsSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.testimonials = payload || [];
    },

    // Get single
    getSingleTestimonialSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.selectedTestimonial = payload || {};
    },

    // Update
    updateTestimonialSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.testimonials = state.testimonials.map((t) =>
        t._id === payload._id ? payload : t
      );
      state.testimonialResponse = payload || {};
    },

    // Delete
    deleteTestimonialSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.testimonials = state.testimonials.filter((t) => t._id !== payload);
      state.testimonialResponse = { message: "Deleted successfully" };
    },

    // Failures
    testimonialFail: (state, { payload }) => {
      state.isLoading = false;
      state.testimonialResponse = payload || {};
    },
  },
});

export const {
  isPending,
  createTestimonialSuccess,
  getTestimonialsSuccess,
  getSingleTestimonialSuccess,
  updateTestimonialSuccess,
  deleteTestimonialSuccess,
  testimonialFail,
} = testimonialSlice.actions;

export default testimonialSlice.reducer;
